<div *ngIf="!isOnline" class="jumbotron my-2">
  <ng-content></ng-content>
</div>
